import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignOostzaanPage() {
  return <LocalPageTemplate cityName="Oostzaan" region="Zaanstreek-Waterland" introText="Professionele websites voor ondernemers in Oostzaan. Wij bouwen websites die jouw bedrijf laten groeien in dit karakteristieke lintdorp aan de rand van Amsterdam." localContext="Oostzaan is een authentiek lintdorp met een hechte gemeenschap, gelegen tussen Zaanstad en Amsterdam. Ondanks de compacte omvang kent het dorp een actief ondernemersleven met lokale winkels, ambachtslieden en dienstverleners. De nabijheid van Amsterdam en de Zaanstreek biedt kansen voor ondernemers die hun bereik willen vergroten. Een professionele website helpt je om zowel de Oostzaanse gemeenschap als het bredere verzorgingsgebied te bedienen." nearbyLocations={[{
    name: 'Zaanstad',
    slug: 'zaanstad'
  }, {
    name: 'Landsmeer',
    slug: 'landsmeer'
  }, {
    name: 'Amsterdam',
    slug: 'amsterdam'
  }, {
    name: 'Wormerland',
    slug: 'wormerland'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Oostzaan?',
    a: 'Een professionele website voor een ondernemer in Oostzaan start vanaf €1.500. We bespreken altijd eerst jouw doelen en maken op basis daarvan een transparante offerte.'
  }, {
    q: 'Hoe word ik gevonden door klanten in Oostzaan en omgeving?',
    a: 'We optimaliseren je website voor lokale zoektermen in Oostzaan, Zaanstad en Amsterdam-Noord. Daarnaast helpen we met je Google Bedrijfsprofiel zodat je zichtbaar bent op Google Maps voor klanten in de buurt.'
  }, {
    q: 'Bouwen jullie ook websites voor ambachtelijke bedrijven?',
    a: "Ja, Oostzaan kent veel ambachtslieden en vakmensen. Wij bouwen websites met projectportfolio's en referenties die jouw vakmanschap professioneel presenteren aan potentiële opdrachtgevers."
  }]} data-id="element-1842" data-mp="1p67dwc08ynou" />;
}